import type { LocationQueryValue } from 'vue-router';

/**
 * Build do app Inter ou query `?tema=inter` (case-insensitive).
 */
export function isAppInter(temaQuery?: LocationQueryValue | LocationQueryValue[]): boolean {
  if (appSettings.VUE_APP_NAME === 'inter') {
    return true;
  }
  const rawTema = Array.isArray(temaQuery) ? temaQuery[0] : temaQuery;
  return typeof rawTema === 'string' && rawTema.toLowerCase() === 'inter';
}
